<template>
  <div class="consulAddDialog" ref="meetingForm">
    <div class="basicTitle">天长市农村社区协商议题办理结果公示单</div>
    <div class="basicSubTitle">社区：{{communityName}}</div>
    <div class="basicGongShi">
      <p class="gongShiContent">
        <span>{{gongShiYear}}</span>年
        <span>{{gongShiMonth}}</span>月
        <span>{{gongShiDay}}</span>日，就反映的
        <span class="zdts">&nbsp;&nbsp;{{ content }}&nbsp;&nbsp;</span>问题，召集有关人员进行协商，会上，通过无记名投票的方式，与会人员就<span class="zdts">&nbsp;&nbsp;{{ content }}&nbsp;&nbsp;</span>问题达成共识，决定：
      </p> 
      <p class="gongShiContent" v-if="appvaldiv==true"><textarea type="text" class="zdts" v-model="publicityContent" style="width:870px;height:750px;resize: none; border: none" placeholder="请输入..."></textarea></p> 
      <p class="gongShiContent" v-if="appvaldiv==false"><textarea type="text" class="zdts" v-model="negotiationContent" style="width:870px;height:750px;resize: none; border: none" placeholder="请输入..."></textarea></p> 
      <p class="gongShiContent">特此公示。</p>
      <p class="gongShiContent">如有疑问，请向社区居委会或居民监督委员会反映。</p>
      <div class="gongShiWeiKuan">
          <p><span>{{communityName}}</span>协商委员会</p>
            <p><span>{{gongShiYear}}</span>年
        <span>{{gongShiMonth}}</span>月
        <span>{{gongShiDay}}</span>日</p>
      </div>
    </div>
    <el-form v-if="appvaldiv">
      <el-form-item label="审核结果：">
        <el-radio disabled v-model="approvInfo.approvalStatus" label="0">审核通过</el-radio>
        <el-radio disabled v-model="approvInfo.approvalStatus" label="1">审核不通过</el-radio> 
      </el-form-item>
      <el-form-item label="审核意见：">
        <el-input disabled v-model="approvInfo.approvalOpinion" style="resize: none;" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div class="queRenBtn">
      <!-- <el-button type="primary" style='margin: 0 0px' @click="dayin">打印</el-button> -->
      <el-button type="primary" style='margin: 0 30px' v-if="approvalStatus == '2'" @click="onSave">确认</el-button>
      <el-button type="primary" style='margin: 0 30px' v-if="approvalStatus == '6'" @click="onUpdate">确认</el-button>
      <el-button type="info" @click="quXiao">取消</el-button>
    </div>
    
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  props: ["ytid","readonlygs"],
  data() {
    return {
      id: this.ytid,
      appvaldiv:false,
      readonlyg:this.readonlygs,
      negotiationContent:'',
      publicityContent:'',
      gongShiProblem: "垃圾乱扔乱倒",
      ghuiYiProblem: "垃圾乱扔乱倒",
      jueyi1: '定时定点倒垃圾',
      jueyi2: '监控监督',
      content: '',
      communityName: '',
      timer: "", //定义一个定时器的变量
      gongShiYear: new Date(), // 获取当前时间
      gongShiMonth: new Date(), // 获取当前时间
      gongShiDay: new Date(), // 获取当前时间
      currentTime: new Date(), // 获取当前时间
      publicityContent1: '',
      publicityContent2: '',
      publicityContent3: '',
      publicityContent4: '',
      publicityContent5: '',
      publicityContent6: '',
      approvInfo:{},
    };
  },
  methods: { 
      getFindConsultById() {
        console.log(this.id,this.readonlygs)
        post("/admin/consult/info/findConsultById",{
          id: this.ytid
        }).then(res => { 
          this.approvalStatus = res.content.approvalStatus+'';
          this.negotiationContent = res.content.negotiationContent 
          this.content = res.content.content;
          if(res.content.communityId == '2'){
            this.communityName = '浔河社区';
          }else if(res.content.communityId == '20'){
            this.communityName = '石街社区';
          }
        })
      },
      async getData() { 
        this.communityName = '';
        this.gongShiYear = '';
        this.gongShiMonth = '';
        this.gongShiDay = '';
        this.content = '';
        this.negotiationContent = '';
      },
      getSjjl() {
        post("/admin/consultPublicity/info/findConsultPublicityList",{
            consultId: this.ytid, 
            pageSize:999,
            pageNo:1,
          }).then(res => {  
              if(res.content.list[0]){
                this.appvaldiv = true;
                console.log(23232,res.content.list[0]);  
                this.approvInfo = res.content.list[0]; 
                console.log(res.content.list[0].publicityContent);
                if(res.content.list[0].publicityContent){
                  this.publicityContent = res.content.list[0].publicityContent 
                }else{
                  this.negotiationContent = this.negotiationContent
                } 
            }
          })
      },
      onSave() {
        post("/admin/consultPublicity/info/insertConsultPublicity",{
          consultId: this.ytid,
          publicityContent: this.negotiationContent,
          publicityTime: this.publicityTime,
        }).then(res => {
          console.log(res)
          this.$emit("close")
        })
      },
      onUpdate() {
        this.publicityTime = this.gongShiYear + '-' + this.gongShiMonth + '-' + this.gongShiDay; 
        post("/admin/consultPublicity/info/updateConsultPublicity",{
          consultId: this.ytid,
          publicityContent: this.publicityContent,
          publicityTime: this.publicityTime,
          approvalStatus: '2'
        }).then(res => {
          console.log(res)
          this.$emit("close")
        })
      },
      dayin() {
        this.$print(this.$refs.meetingForm);
      },
      quXiao() {
        this.$emit("close")
      },
  },
   created() {
    var _this = this; //声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(function () {
        _this.gongShiYear = new Date().getFullYear();
        _this.gongShiMonth = (new Date().getMonth() + 1);
        _this.gongShiDay = new Date().getDate();
    }, 1000);
  },
  beforeDestroy() {
    if(this.timer) {
      clearInterval(this.timer); //在vue实例销毁前，清除我们的定时器
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.getFindConsultById();
      this.getSjjl();
    }) 
  }
};
</script>

<style lang="less" scoped>
.consulAddDialog {
    margin: 40px;
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.basicTitle {
   font-size: 25px; 
   text-align: center;
   margin-bottom: 30px;
}
.basicSubTitle {
   font-size: 22px; 
   margin-bottom: 20px;
}
.basicGongShi {
  border: 1px solid #000;
  width: 980px;
  height: 1200px;
  font-size: 18px;
  .gongShiContent {
      line-height:61px;
      text-indent:60px;
      padding: 5px 20px;
      position: relative;
  }
  .gongShiWeiKuan {
      line-height:25px;
      // margin-top: 330px;
      text-align: right;
      position: relative;
      p {
          margin-right: 20px;
          margin-bottom: 20px;
      }
  }
}
.queRenBtn {
    margin-top: 30px;
  display: flex;
  justify-content: center;
}

</style>